<template>
    <div class="hours" v-if="internalValue">
        <div class="hour" v-for="(item, index) in internalValue">
            <form-select label="Jours" multiple="false" v-model="item.day_week" :default="item.day_week" :options="weekDays"></form-select>
            <form-time label="Heure d'ouverture" v-model="item.start_hour"></form-time>
            <form-time label="Heure de fermeture" v-model="item.end_hour"></form-time>
            <button @click="deleteOpeningHour(index)"><i class="icon icon-icon_delete"></i> Supprimer</button>
        </div>
        <button @click="addOpeningHour()">Ajouter</button>
    </div>
</template>

<script>

    export default {
        name: 'OpeningHours',
        props: ['value'],
        data: function () {
            return {
                internalValue: [],
                hours: [],
                weekDays: [
                    {id:1, name:'Lundi'},
                    {id:2, name:'Mardi'},
                    {id:3, name:'Mercredi'},
                    {id:4, name:'Jeudi'},
                    {id:5, name:'Vendredi'},
                    {id:6, name:'Samedi'},
                    {id:7, name:'Dimanche'}
                ],
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            addOpeningHour: function() {
                this.internalValue.push({start_hour:'00:00:00',end_hour:'00:00:00'})
            },
            deleteOpeningHour: function(index) {
                this.internalValue.splice(index, 1);
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/OpeningHours.vue